// src/supabaseClient.js – cliente padrão (publishable/anon)
import { createClient } from '@supabase/supabase-js';

// URL do seu projeto Supabase (copie de Project Settings → API)
// Usando variáveis de ambiente para maior segurança e flexibilidade
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;

// Chave publishable (anon) – pode ficar no front‑end porque tem permissões limitadas via RLS
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Validação: garantir que as variáveis de ambiente existem
if (!supabaseUrl || !supabaseKey) {
    throw new Error('Missing Supabase environment variables. Please check your .env file.');
}

export const supabase = createClient(supabaseUrl, supabaseKey, {
    auth: {
        detectSessionInUrl: false
    }
});

// Cliente Admin (Service Role) - Opcional, apenas se a chave estiver disponível
const supabaseServiceKey = import.meta.env.VITE_SUPABASE_SERVICE_ROLE_KEY;
export const supabaseAdmin = supabaseServiceKey
    ? createClient(supabaseUrl, supabaseServiceKey, {
        auth: {
            autoRefreshToken: false,
            persistSession: false,
            detectSessionInUrl: false,
            storageKey: 'sb-admin-auth-token'
        }
    })
    : null;
